import styled from "styled-components";
import {WheelOfJackpotbetDialogDefaultBox} from "./wheel-of-jackpotbet-dialog.default.box";
import {baseColors} from "../../../../themes/definitions/casino777/base-colors";

export const WheelOfJackpotbetDialogCasino777Box = styled(WheelOfJackpotbetDialogDefaultBox)`
    padding-top: 10rem;
    box-shadow: inset 0px -1px 6px 2px #8CD1BA40, inset 0px 0px 2px 0px #FCF6D580, 0px 8px 20px 0px #00000025;
    background-image: none;
    border: 1px solid #FCF6D580;
    background-color: ${baseColors.base02};

    @media ${({theme}) => `${theme.mediaQuery.mAndBelow} and ${theme.mediaQuery.landscape}`} {
        padding-top: 22px;
        padding-bottom: 14px;
    }
`;